import React, { useState } from "react";
import { Button } from "@material-ui/core";

import { RevisionRequestDialog } from "./WorkflowStatus";

// ModalWorkflowActions renders the "Duyệt" / "Hủy duyệt" + "Yêu cầu khai lại"
// buttons inside a work-type UpdateModal. Each UpdateModal already owns the
// Redux dispatch wiring for accept + requestRevision, so this component just
// surfaces the buttons + handles the reason dialog state.
//
// Props:
//   row              — full work row (must have id, accepted, revisionStatus,
//                       purposeId, locked).
//   role             — current user role; buttons hidden unless "sudo-admin".
//   onAccept         — () => Promise<boolean> that toggles accepted on the BE.
//   onRequestRevision— (reason: string) => Promise<boolean> that submits the
//                       revision request.
//   onAfterAction    — optional () => void called after a successful action
//                       (useful to close the modal so the table reloads).
//
// Hidden conditions (match the table's action column):
//   • not admin → render nothing
//   • row missing / unsaved → render nothing
//   • row.locked → render nothing (locked rows can't move workflow)
//   • row.purposeId === 4 ("Công bố cũ") → render nothing
export default function ModalWorkflowActions({
  row,
  role,
  onAccept,
  onRequestRevision,
  onAfterAction,
}) {
  const [revisionOpen, setRevisionOpen] = useState(false);
  const [revisionSubmitting, setRevisionSubmitting] = useState(false);
  const [accepting, setAccepting] = useState(false);

  if (!row || !row.id) return null;
  if (role !== "sudo-admin") return null;
  if (row.locked) return null;
  if (row.purposeId === 4) return null;

  const handleAcceptClick = async () => {
    if (accepting) return;
    setAccepting(true);
    try {
      const ok = await onAccept();
      if (ok && onAfterAction) onAfterAction();
    } finally {
      setAccepting(false);
    }
  };

  const handleSubmitRevision = async (reason) => {
    if (revisionSubmitting) return;
    setRevisionSubmitting(true);
    try {
      const ok = await onRequestRevision(reason);
      if (ok) {
        setRevisionOpen(false);
        if (onAfterAction) onAfterAction();
      }
    } finally {
      setRevisionSubmitting(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color={row.accepted ? "secondary" : "primary"}
        disabled={accepting}
        onClick={handleAcceptClick}
        style={{ padding: "8px 24px", fontSize: "15px", marginLeft: 8 }}
      >
        {accepting ? "Đang xử lý…" : row.accepted ? "Hủy duyệt" : "Duyệt"}
      </Button>
      {/* "Yêu cầu khai lại" hidden when row is already in `requested` state
          to avoid double-asking. Same logic as <RevisionRequestLink>. */}
      {row.revisionStatus !== "requested" && (
        <Button
          variant="outlined"
          onClick={() => setRevisionOpen(true)}
          style={{
            padding: "8px 24px",
            fontSize: "15px",
            marginLeft: 8,
            color: "#e53935",
            borderColor: "#e53935",
          }}
        >
          Yêu cầu khai lại
        </Button>
      )}
      <RevisionRequestDialog
        row={revisionOpen ? row : null}
        submitting={revisionSubmitting}
        onClose={() => setRevisionOpen(false)}
        onSubmit={handleSubmitRevision}
      />
    </>
  );
}
